/* eslint-disable require-jsdoc */
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { NavLink, Link } from 'react-router-dom';
import Logo from '../../images/logo.jpg';
import LinkItem from '../LinkItem/linkitem';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './Header.css'
function Header(props) {
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [value, setValue] = useState(null);
  const [message, setMessage] = useState('');
  const [inputVal, setInputVal] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [poolName, setPoolName] = useState(localStorage.getItem('poolname'));
  const [dealType, setDealType] = useState(localStorage.getItem('DealType'));
  const [orgName, setOrgName] = useState(localStorage.getItem('OrgName') || null);
  const [currentUser, setCurrentUser] = useState(localStorage.getItem('username'));

  useEffect(() => {
    if (currentUser !== null) {
      const firstname = currentUser;
      const namefirstletter = firstname.charAt(0).toUpperCase();
      setCurrentUser(namefirstletter);
    }
  }, [currentUser]);

  const onOpenModal1 = (value) => {
    console.log("MODAL " + value);
    setOpen1(true);
    setValue(value);
  };

  const onCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-5 col-sm-12 align-self-center">
          <LinkItem to={'#nogo'} className="logo_img" title={''} icon={Logo} > </LinkItem>
        </div>
        <div className="col-md-7 col-sm-12 d-flex justify-content-end align-items-center">
          <React.Fragment>
            {/* {orgName === "originator" ?
              <React.Fragment>
                <div className="header_right">
                  <React.Fragment>
                    <p className="orgname">Logged in as <span> {orgName} </span> </p>
                    <ul className="preprocessing_menu">
                      <li><Button
                        variant="outlined"
                        color="primary" >
                        Pre Processing <MoreVertIcon /> </Button>
                        <ul>
                          <li><MenuItem><NavLink to={'/preprocessingviewloans/'} id="viewloanlink"> View LMS Data</NavLink></MenuItem></li>
                          <li><MenuItem><NavLink to={'/bulkupload/'} id="viewloanlink"> Bulk Document Uploads</NavLink></MenuItem></li>
                        </ul>
                      </li>
                      <li className="userInfo"><LinkItem to={'#nogo'} title={currentUser} > </LinkItem></li>
                    </ul>
                  </React.Fragment>
                </div>
              </React.Fragment>
              : */}
              <React.Fragment>
                <div className="header_right d-flex align-items-center">
                  <React.Fragment>
                    <p className="orgname mb-0">Logged in as <span> {orgName} </span> </p>
                    <ul className="preprocessing_menu mb-0">
                      <li className="userInfo"><LinkItem to={'#nogo'} title={currentUser} > </LinkItem></li>
                    </ul>
                  </React.Fragment>
                </div>
              </React.Fragment>
            {/* } */}
          </React.Fragment>
        </div>
      </div>

      <div className="tableSearch" id="sub_heading">
        <div className="row align-items-center">
          <div className="col-md-4 col-sm-12">
            {props.pageTitle === 'REPORTS' ?
              <React.Fragment>
                <div className="pageHeading">
                  {poolName === undefined ? ' ' :
                    <React.Fragment>
                      <div><p>Deals&nbsp;<ArrowForwardIosIcon fontSize="small"></ArrowForwardIosIcon><span className="dealId">{poolName}</span></p></div>
                    </React.Fragment>
                  }
                  <span className="pageTitle"> {props.pageTitle}
                    {props.total_deals === undefined ? ' ' :
                      <span className="total_deals">{props.total_deals}</span>
                    }
                  </span>
                </div>
              </React.Fragment> :
              <React.Fragment>
                <div className="pageHeading ">
                  <span className="pageTitle"> {props.pageTitle}
                    {props.total_deals === undefined ? ' ' :
                      <span className="total_deals">{props.total_deals}</span>
                    }
                    {props.dealId === undefined ? ' ' :
                      <span className="dealId">{props.dealId}</span>
                    }
                  </span>
                </div>
              </React.Fragment>
            }
          </div>
          <div className="col-md-8 col-sm-12">
            {props.pageTitle !== 'REPORTS' ? ' ' :
              <div className="page-contents11">
                <p className='fontsizeset'>&nbsp;<InfoOutlinedIcon fontSize="large" className="imgcolor"></InfoOutlinedIcon> &nbsp;In the event 5% did not equal a whole number, additional files are verified to ensure meeting verification requirements</p>
              </div>
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Header;
